import { TrackService } from './track-service';

let trackService = new TrackService();

export { trackService }